/* eslint-disable react/prop-types */
import Flex from 'components/common/Flex';
import TooltipComponent from 'components/wise-components/TooltipComponent';
import WiseScheduleModal from 'components/wise-modals/WiseScheduleModal';
import { months } from 'data/month';
import { thousandSeparator } from 'helpers/helper';
import React, { useState } from 'react';
import { Button, Form, Offcanvas } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { routePaths } from 'routes/routePaths';

const ReviewItem = ({ className = 'mb-3', title, value }) => {
  return (
    <Flex alignItems="center" justifyContent="between" className={className}>
      <p className="mb-0">{title}</p>
      <p className="mb-0">{value}</p>
    </Flex>
  );
};

function TransferReview() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [scheduleDate, setScheduleDate] = useState({});
  const [showScheduledModal, setShowScheduledModal] = useState(false);

  return (
    <>
      <div>
        <h3 className="fs-2 fw-semi-bold text-md-center mb-4">
          Review details of your transfer
        </h3>
        <div className="border rounded-4 p-3">
          <div>
            <Flex alignItems="center" justifyContent="between" className="mb-4">
              <p className="mb-0 text-1000 fw-medium">Transfer details</p>
              <Button
                onClick={() => navigate(routePaths.HOME)}
                className="bg-transparent border-0 p-0 text-800 lh-1 shadow-none text-decoration-underline"
              >
                Edit
              </Button>
            </Flex>

            <ReviewItem
              title="You send exactly"
              value={
                <span className="mb-0 fs-2 fw-semi-bold text-1000">
                  {thousandSeparator(5000)} PLN
                </span>
              }
            />
            <ReviewItem
              title="Total fees (included)"
              value={<span>{thousandSeparator(98.25)} PLN</span>}
            />
            <ReviewItem
              title="Total amount we'll convert"
              value={<span>{thousandSeparator(4901.75)} PLN</span>}
            />
            <Flex alignItems="center" justifyContent="between" className="mb-2">
              <TooltipComponent
                position="bottom"
                text={
                  <p className="mb-0 text-start">
                    For this transfer, the exchange rate isn't guaranteed - Wise
                    will use the exchange rate at the moment of receiving your
                    money
                    <a
                      href="#"
                      target="_blank"
                      className="d-block text-decoration-underline"
                    >
                      Learn more
                    </a>
                  </p>
                }
                btnText={
                  <Button className="bg-transparent text-start border-0 p-0 text-800 lh-1 shadow-none text-decoration-underline d-md-block d-none">
                    Exchange rate (Not guaranteed)
                  </Button>
                }
              />
              <Button
                onClick={() => setShow(true)}
                className="bg-transparent text-start border-0 p-0 text-800 lh-1 shadow-none text-decoration-underline d-md-none "
              >
                Exchange rate (Not guaranteed)
              </Button>
              <p className="mb-0">32.7730</p>
            </Flex>
            <ReviewItem
              title="You get"
              value={
                <span className="mb-0 fs-2 fw-semi-bold text-1000">
                  {thousandSeparator(160645)} KES
                </span>
              }
            />
          </div>
          <hr />
          <div>
            <Flex alignItems="center" justifyContent="between" className="mb-4">
              <p className="mb-0 text-1000 fw-medium">Recipient details</p>
              <Button
                onClick={() => navigate(routePaths.CONTACT_EXISTING)}
                className="bg-transparent border-0 p-0 text-800 lh-1 shadow-none text-decoration-underline"
              >
                Change
              </Button>
            </Flex>
            <ReviewItem title="Name" value="Hillary Kiprono Langat" />
            <ReviewItem title="Email" value="langat.paponya@gmail.com" />
            <ReviewItem title="Beneficiary's bank" value="07" />
            <ReviewItem title="Account number" value="1003337018" />
          </div>
          <hr />
          <div>
            <Flex alignItems="center" justifyContent="between" className="mb-4">
              <p className="mb-0 text-1000 fw-medium">Schedule details</p>
              <Button
                onClick={() => setShowScheduledModal(true)}
                className="bg-transparent border-0 p-0 text-800 lh-1 shadow-none text-decoration-underline"
              >
                Edit
              </Button>
            </Flex>
            <ReviewItem
              title="Sending"
              value={
                Object.keys(scheduleDate).length
                  ? `${new Date(scheduleDate?.date).getDate()} ${
                      months[new Date(scheduleDate?.date).getMonth()]
                    } ${new Date(scheduleDate?.date).getFullYear()}`
                  : 'Now'
              }
            />
            <ReviewItem title="Should arrive" value="in 30 minutes" />
            <ReviewItem
              title="Repeats"
              value={
                Object.keys(scheduleDate).length &&
                scheduleDate?.repeatsData.title !== 'Never'
                  ? scheduleDate?.repeatsData?.text
                  : 'Never'
              }
            />
            {Object.keys(scheduleDate).length && scheduleDate?.endDate ? (
              <ReviewItem
                title="End Date"
                value={
                  Object.keys(scheduleDate).length
                    ? `${new Date(scheduleDate?.endDate).getDate()} ${
                        months[new Date(scheduleDate?.endDate).getMonth()]
                      } ${new Date(scheduleDate?.endDate).getFullYear()}`
                    : 'Never'
                }
              />
            ) : null}
          </div>
        </div>

        <Form className="mt-4">
          <Form.Group>
            <Form.Label>Reference (optional)</Form.Label>
            <Form.Control
              className="py-2 rounded-3"
              type="email"
              placeholder="Message to Hillary (only sent by email)"
            />
          </Form.Group>
          <Button
            type="submit"
            variant="primary"
            className="flex-1 rounded-5 h-48px w-100 mt-4"
            onClick={() => navigate(routePaths.PAY_URL)}
          >
            Confirm and continue
          </Button>
        </Form>
      </div>
      <Offcanvas
        show={show}
        placement={'bottom'}
        onHide={() => setShow(false)}
        className="c-offcanvas-style"
      >
        <div className="offcanvas-close-line" />

        <Offcanvas.Body className="mt-4">
          <p className="mb-0 px-3 text-start">
            For this transfer, the exchange rate isn't guaranteed - Wise will
            use the exchange rate at the moment of receiving your money
            <a
              href="#"
              target="_blank"
              className="d-block text-decoration-underline"
            >
              Learn more
            </a>
          </p>
        </Offcanvas.Body>
      </Offcanvas>

      <WiseScheduleModal
        show={showScheduledModal}
        handleClose={() => setShowScheduledModal(false)}
        setScheduleDate={setScheduleDate}
      />
    </>
  );
}

export default TransferReview;
